export default "__VITE_ASSET__CAlSlodV__"